
// tab names at Home view
export const ALLRESULTS = "all results";
export const MYSUBMISSIONS = "my submissions";


export const SEARCH_MODES = {
  ALL_ANTIBODIES: "all_antibodies",
  MY_ANTIBODIES: "my_antibodies",
  SEARCHED_ANTIBODIES: "search_antibodies",
  ALL_FILTERED_AND_SEARCHED_ANTIBODIES: "filtered_and_searched_antibodies",
  MY_FILTERED_AND_SEARCHED_ANTIBODIES: "my_filtered_and_searched_antibodies",
}

export const PAGE_SIZE = 10;
export const LIMIT_NUM_RESULTS = 10000

export const BLANK_FILTER_MODEL = { columnField: "abName", operatorValue: "equals", value: "", id: "", operator: "AND" };

export const modelType = {
  filter: "filter",
  sort: "sort"
}